module.exports = __webpack_public_path__ + "img/05-助力飞.7dca2527.png";